module.exports = __webpack_public_path__ + "static/img/01imgSchool.c48da1d7.png";